export function backSignup(url) {
  const safeUrl = url || 'https://app.rdstation.com.br'
  const backUrl = new URL(safeUrl)?.origin
  return backUrl ? `${backUrl}/signup/?new_second_account_layout=true` : `https://app.rdstation.com.br/signup/?new_second_account_layout=true`
}
